
import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@elparking/components'
import CarTypeCard from './CarTypeCard'
import { FormattedMessage } from 'react-intl'
import { VehicleCompact, VehicleEconomy, VehicleFamily, VehicleIntermediate, VehicleSelection } from '../../../Icons'
import {
    RENTAL_CAR_VEHICLE_SUBCATEGORY_ECO,
    RENTAL_CAR_VEHICLE_SUBCATEGORY_SMALL,
    RENTAL_CAR_VEHICLE_SUBCATEGORY_COMPACT,
    RENTAL_CAR_VEHICLE_SUBCATEGORY_BIG,
    RENTAL_CAR_VEHICLE_SUBCATEGORY_SELECTION,
} from 'commons/js/constants'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'
const defaultCarTypes = {
    [RENTAL_CAR_VEHICLE_SUBCATEGORY_ECO]: {
        icon: VehicleEconomy,
        label: <FormattedMessage defaultMessage='Económico' />,
    },
    [RENTAL_CAR_VEHICLE_SUBCATEGORY_SMALL]: {
        icon: VehicleCompact,
        label: <FormattedMessage defaultMessage='Pequeño' />,
    },
    [RENTAL_CAR_VEHICLE_SUBCATEGORY_COMPACT]: {
        icon: VehicleIntermediate,
        label: <FormattedMessage defaultMessage='Mediano' />,
    },
    [RENTAL_CAR_VEHICLE_SUBCATEGORY_BIG]: {
        icon: VehicleFamily,
        label: <FormattedMessage defaultMessage='Grande' />,
    },

    [RENTAL_CAR_VEHICLE_SUBCATEGORY_SELECTION]: {
        icon: VehicleSelection,
        label: <FormattedMessage defaultMessage='Selección' />,
    },
}

export const CarTypeSelector = ({ filter, setFilters, isModal, isLoading }) => {
    const onChange = (value) => {
        trackTealiumEvent(RentalCarEvents.applyFiltersLink)
        if (filter.includes(value)) {
            setFilters(filter.filter((item) => item !== value))
        } else {
            setFilters([...filter, value])
        }
    }

    return <Flex width='100%' flexDirection='row' flexWrap={['wrap', 'nowrap']}>
        {Object.keys(defaultCarTypes).map((type) => <CarTypeCard
          checked={filter.includes(type)}
          width={['50%', '100%']}
          icon={defaultCarTypes[type].icon}
          label={defaultCarTypes[type].label}
          key={`car_type_${type}_${isModal}`}
          keyId={type + '_' + isModal}
          name={type}
          onChange={() => onChange(type)}
          isLoading={isLoading}
        />)
        }

    </Flex>
}

CarTypeSelector.propTypes = {
    filter: PropTypes.array,
    setFilters: PropTypes.func,
    isModal: PropTypes.bool,
    isLoading: PropTypes.bool,
}

export {
    defaultCarTypes,
}

export default CarTypeSelector
